export default __webpack_public_path__ + "static/media/uploader-ascensiaContour-3.4c3ff94e.png";